import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Career from './pages/Career';
import Contact from './pages/Contact';
import Awards from './pages/Awards';
import ProductCollection from './pages/ProductCollection';
import ProductInfo from './pages/ProductInfo';
import Manufacturing from './pages/Manufacturing';
import JobApplicationPage from './pages/JobApplicationPage';
import ApplicationSuccessPage from './pages/ApplicationSuccessPage';
import ScrollToTop from './components/common/ScrollToTop';
import Seo from './components/common/Seo';

const NotFound = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
    <Seo
      title="Page Not Found | Agastya Agro Limited"
      description="The page you are looking for is unavailable. Return to Agastya Agro Limited to explore crop protection products and support."
      noIndex
    />
    <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
    <p className="text-xl text-gray-600 mb-8">Page not found</p>
    <Link to="/" className="bg-black text-white px-6 py-3 rounded-full hover:bg-gray-800 transition-colors">
      Go Home
    </Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop behavior="smooth" />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<About />} />
          <Route path="career" element={<Career />} />
          <Route path="career/apply/:jobId" element={<JobApplicationPage />} />
          <Route path="career/application-success" element={<ApplicationSuccessPage />} />
          <Route path="products" element={<ProductCollection />} />
          <Route path="products/:category" element={<ProductCollection />} />
          <Route path="product/:id" element={<ProductInfo />} />
          <Route path="awards" element={<Awards />} />
          <Route path="contact" element={<Contact />} />
          <Route path="manufacturing" element={<Manufacturing />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
